import { ListPageHeaderProps } from '../../../../ui/components/pure/page-headers/list/list-page-header.component';
import { CouriersListControlsState } from '../../list/logic/couriers-list-query.map';

export const PENDING_COURIERS_EMPTY_MESSAGE = 'No couriers awaiting approval.';

/** The couriers list header without the status filter or actions: the queue is pending only, and reviewed per row. */
export function makePendingCouriersPageHeaderProps(
  couriersCount: number,
  form: CouriersListControlsState,
  onFormInput: (update: Partial<CouriersListControlsState>) => void,
  carrierFilter: { options: { label: string; value: string }[]; loading: boolean; onOpen(): void }
): ListPageHeaderProps<CouriersListControlsState> {
  return {
    title: 'Pending Couriers',
    subtitle: `${couriersCount} ${couriersCount === 1 ? 'Courier' : 'Couriers'}`,
    controls: {
      form,
      onFormInput,
      inputs: [
        {
          type: 'auto-complete',
          label: 'Carrier',
          field: 'groupID',
          options: carrierFilter.options,
          onOpen: carrierFilter.onOpen,
          loading: carrierFilter.loading,
          isAdvanced: true,
          halfWidthOnMobile: true
        },
        {
          type: 'text',
          label: 'Search',
          field: 'searchTerm'
        }
      ]
    }
  };
}
